<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.fqc_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="fqc_qty">
            <label class="weui-form-preview__label">{{customLabel.fqc_qty || "收料数量"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.fqc_qty }} {{ form.main.pr_unit }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="fqc_prodcode">
            <label class="weui-form-preview__label">{{customLabel.fqc_prodcode || "物料编号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_prodcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_detail
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_orispeccode
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">检验标准</div>
        <custom-layout
          :view-config="customViewConfig"
          class="weui-form-preview__bd form-detail-preview"
        >
          <div class="weui-form-preview__item" slot="fqc_type">
            <label class="weui-form-preview__label">{{customLabel.fqc_type || "检验类型"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_type
            }}</span>
          </div>
          <div
            class="weui-form-preview__item" slot="fqc_sample"
            v-if="form.main.fqc_type == '抽检'"
          >
            <label class="weui-form-preview__label">{{customLabel.fqc_sample || "抽样标准"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_sample
            }}</span>
          </div>
          <div
            class="weui-form-preview__item" slot="fqc_sample_std_qty"
            v-if="form.main.fqc_type == '抽检'"
          >
            <label class="weui-form-preview__label">{{customLabel.fqc_sample_std_qty || "标准抽样数"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_sample_std_qty
            }}</span>
          </div>
          <div
            class="weui-form-preview__item" slot="fqc_aql"
            v-if="form.main.fqc_type == '抽检'"
          >
            <label class="weui-form-preview__label">{{customLabel.fqc_aql || "AQL标准"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_aql
            }}</span>
          </div>
          <div
            class="weui-form-preview__item" slot="fqc_aql_ng_max"
            v-if="form.main.fqc_type == '抽检'"
          >
            <label class="weui-form-preview__label">{{customLabel.fqc_aql_ng_max || "最大报废允收数"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_aql_ng_max
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div
        class="form-preview weui-form-preview"
        v-if="form.main.fqc_type == '抽检'"
      >
        <div class="weui-panel__hd">抽样结果</div>
        <custom-layout
          :view-config="customViewConfig" slot="fqc_sample_qty"
          class="weui-form-preview__bd form-detail-preview"
        >
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{customLabel.fqc_sample_qty || "抽样数量"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_sample_qty
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fqc_sample_ok_qty">
            <label class="weui-form-preview__label">{{customLabel.fqc_sample_ok_qty || "抽样合格数"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_sample_ok_qty
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fqc_sample_ng_qty">
            <label class="weui-form-preview__label">{{customLabel.fqc_sample_ng_qty || "抽样不合格数"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_sample_ng_qty
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">判定结果</div>
        <custom-layout
          :view-config="customViewConfig"
          class="weui-form-preview__bd form-detail-preview"
        >
          <div class="weui-form-preview__item" slot="fqc_result">
            <label class="weui-form-preview__label">{{customLabel.fqc_result || "判定结果"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_result
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fqc_okqty">
            <label class="weui-form-preview__label">{{customLabel.fqc_okqty || "合格数量"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.fqc_okqty }} {{ form.main.pr_unit }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="fqc_ngqty">
            <label class="weui-form-preview__label">{{
              form.main.fqc_type == "全检" ? "报废数量" : "不合格数量"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.fqc_ngqty }} {{ form.main.pr_unit }}</span
            >
          </div>
          <div class="weui-form-preview__item" v-if="form.main.fqc_ng_desc" slot="fqc_ng_desc">
            <label class="weui-form-preview__label">{{
              form.main.fqc_type == "全检" ? "报废描述" : "不良描述"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_ng_desc
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.fqc_ng_reason" slot="fqc_ng_reason">
            <label class="weui-form-preview__label">{{
              form.main.fqc_type == "全检" ? "报废原因" : "不良原因"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_ng_reason
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.fqc_ng_handle" slot="fqc_ng_handle">
            <label class="weui-form-preview__label">{{
              form.main.fqc_type == "全检" ? "报废处理" : "不良处理"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_ng_handle
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.fqc_rw_desc" slot="fqc_rw_desc">
            <label class="weui-form-preview__label">{{customLabel.fqc_rw_desc || "返修描述"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_rw_desc
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.fqc_rw_reason" slot="fqc_rw_reason">
            <label class="weui-form-preview__label">{{customLabel.fqc_rw_reason || "返修原因"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_rw_reason
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.fqc_rw_handle" slot="fqc_rw_handle">
            <label class="weui-form-preview__label">{{customLabel.fqc_rw_handle || "返修处理"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.fqc_rw_handle
            }}</span>
          </div>
        </custom-layout>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/qc/makefqc",
      caller: "MakeFqc",
      xtype: "qc-makefqc-formpanel",
    };
  },
};
</script>